export default function ({ app, route }) {
  app.i18n.locale = app?.$cookiz?.get('langCode') || app.i18n.defaultLocale
}
